import React from 'react';
import PropTypes from 'prop-types';
import { RenderSectionParagraph } from '../';
import classes from './HeaderSection.module.scss';

const HeaderSection = (props) => {
    const { header_block } = props?.data || {};

    if (!header_block?.visible) return null;
    
    return (
        <div className={classes.HeaderSection}>
            {header_block?.title ? (<h1 className={classes.Title}>{header_block?.title}</h1>) : null}
            {header_block?.subtitle ? (<p className={classes.Subtitle}>{header_block?.subtitle}</p>) : null}
            {header_block?.description?.length !== 0 ? 
                <RenderSectionParagraph data={header_block?.description} /> : null}
        </div>
    )
}

HeaderSection.propTypes = {}

export default HeaderSection;